import { render, staticRenderFns } from "./ad-slot.vue?vue&type=template&id=0a0e9c42"
import script from "./ad-slot.vue?vue&type=script&lang=js"
export * from "./ad-slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports